export const readFileAsync = (file: File): Promise<string | ArrayBuffer | null> => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
            resolve(fileReader.result)
        })

        fileReader.addEventListener('error', reject)

        fileReader.readAsArrayBuffer(file)
    })
}

export const readFileAsDataUrlAsync = (file: File): Promise<string | ArrayBuffer | null> => {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
            resolve(fileReader.result)
        })

        fileReader.addEventListener('error', reject)

        fileReader.readAsDataURL(file)
    })
}
